<template>
  <div class="px-1">
    <NavigationBreadcrumb
      :items="breadcrumb_items"
      :egressProfileId="egress_profile_id"
      :showEgressProfile="true"
      :showMatrix1="true"
      :showMatrix2="true"
      :showMatrix3="true"
      :showMatrix4="true"
      :showCurricularMesh="true"
    ></NavigationBreadcrumb>
    <StudyPlan
      :egress_profile_id="egress_profile_id"
      :allows_crud="allows_crud"
      :can_update="can_update"
    ></StudyPlan>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as names from "@/store/names";
export default {
  name: "StudyPlanView",
  components: {
    StudyPlan: () => import("./StudyPlan"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  data() {
    return {
      egress_profile_id: Number(this.$route.params.egress_profile_id),
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      careers: names.CAREERS,
      egressProfiles: names.EGRESS_PROFILES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames("mesh.career", true, "Programas"),
          to: "/careers",
        },
        {
          text: this.$t("reusable.breadcrumb.studyPlan"),
          dropdownOptions: [
            "showEgressProfile",
            "showMatrix1",
            "showMatrix2",
            "showMatrix3",
            "showMatrix4",
            "showStudyPlan",
            "showCurricularMesh",
          ],
        },
      ];
    },
    egressProfile() {
      if (!this.egress_profile_id) return [];
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    can_update() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (
        this.career &&
        this.egress_profile_id &&
        this.user &&
        !["ADMINISTRATIVOS INSTRUCCIONALES"].some((group) =>
          this.user.group_names.includes(group)
        )
      ) {
        return (
          [
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
            "DIRECTORES DE CARRERA (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group)) &&
          (this.$hasObjectPermission(
            "mesh.faculty",
            "change",
            this.career.faculty
          ) ||
            this.$hasObjectPermission(
              "mesh.egressprofile",
              "change",
              this.egress_profile_id
            ))
        );
      }
      return false;
    },
    // can_delete() {
    //   if (
    //     (this.user &&
    //       [
    //         "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
    //         "DIRECTIVOS ACADÉMICOS (CAMPUS)",
    //       ].some((group) => this.user.group_names.includes(group))) ||
    //     this.user.is_superuser
    //   )
    //     return true;
    //   if (
    //     this.career &&
    //     this.egress_profile_id &&
    //     this.user &&
    //     !["ADMINISTRATIVOS INSTRUCCIONALES"].some((group) =>
    //       this.user.group_names.includes(group)
    //     )
    //   ) {
    //     return (
    //       [
    //         "DIRECTIVOS FACULTAD O ESCUELA",
    //         "DIRECTORES DE CARRERA",
    //         "DIRECTORES DE CARRERA (CAMPUS)",
    //       ].some((group) => this.user.group_names.includes(group)) &&
    //       (this.$hasObjectPermission(
    //         "mesh.faculty",
    //         "delete",
    //         this.career.faculty
    //       ) ||
    //         this.$hasObjectPermission(
    //           "mesh.career",
    //           "delete",
    //           this.career.id
    //         ) ||
    //         this.$hasObjectPermission(
    //           "mesh.egress_profile",
    //           "delete",
    //           this.egress_profile_id
    //         ))
    //     );
    //   }
    //   return false;
    // },
    allows_crud() {
      if (
        this.egressProfile &&
        !this.egressProfile.is_closed &&
        this.can_update
        // (this.can_update || this.can_delete)
      ) {
        const has_permission = this.$hasPermissions(
          "mesh.change_egressprofile"
        );
        if (has_permission) {
          this.$store.commit(names.MUTATE_VISIBILITY_CRUD, true);
          return has_permission;
        } else {
          return false;
        }
      } else {
        this.$store.commit(names.MUTATE_VISIBILITY_CRUD, false);
        return false;
      }
    },
  },
  methods: {},
  mounted() {
    if (
      this.user &&
      this.user.student_card &&
      this.user.group_names.includes("ESTUDIANTES") &&
      this.user.student_card.egress_profile != this.egress_profile_id
    ) {
      this.$router.push({
        name: "Page403",
      });
    }
    if (this.user && this.user.group_names.includes("PROFESORES")) {
      this.$restful
        .Get(`/mesh/fully_visible_professor_egress_profiles/`)
        .then((response) => {
          if (!response.includes(this.egress_profile_id)) {
            this.$router.push({
              name: "Page403",
            });
          }
        });
    }
  },
  beforeDestroy() {
    this.$store.commit(names.RESET_TITLE_OF_THE_PRINT);
  },
  created() {
    this.$store
      .dispatch(names.FETCH_EGRESS_PROFILE, this.egress_profile_id)
      .then((egress_profile) => {
        this.$store.dispatch(names.FETCH_CAREER, egress_profile.career);
        this.$store.commit(
          names.MUTATE_TITLE_OF_THE_PRINT,
          `${this.$t("studyPlan.studyPlanView.studyPlan")} - ${
            egress_profile.name
          }`
        );
      });
    this.$store.dispatch(names.FETCH_PROFILE_CYCLES, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_TIME_ALLOCATIONS);
    this.$store.dispatch(names.FETCH_FORMATION_LINES);
  },
};
</script>

<style scoped>
</style>
